// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterAddress_root__ehVQH","title":"FooterAddress_title__wXVFG","subTitle":"FooterAddress_subTitle__IyJ_u","country":"FooterAddress_country__R4SBi"};